import { Injectable, NotFoundException } from "@nestjs/common";
import { OntOpticalDdmInfo, OntsBySerialNum } from "@ip6m/types";

@Injectable()
export class DeviceService {
    
    public ONTs: OntsBySerialNum[] = [];  // Indexed by OLT ID

    get stat() {
        return Object.keys(this.ONTs).length;
    }

    get getOnts() {
        let result: OntsBySerialNum = {};
        this.ONTs.forEach(Onts => {
            result = {...Onts};
        })
        return result;
    }

    getOntsByOlt(oltid) {
        return this.ONTs[oltid];
    }

    getOnt(sn: string, oltId: number = null) {
        let calculatedOltId = 0;
        if(oltId === null) {
            calculatedOltId = this.getOnts[sn].oltId;
        }
        else {
            calculatedOltId = oltId;
        }

        if(typeof this.ONTs[calculatedOltId][sn] != 'undefined') {
            return this.ONTs[calculatedOltId][sn];
        }
        else {
            throw new NotFoundException('Ont not found');
        }
        
    }

    setDdmData(oltId, sn: string, data: OntOpticalDdmInfo) {
        this.ONTs[oltId][sn].ddm = data;
    }

    deleteOnt(oltId, sn: string){
        delete this.ONTs[oltId][sn];
    }
}
